import { render } from "./ProductOptionExCreate.vue?vue&type=template&id=06963e38"
import script from "./ProductOptionExCreate.vue?vue&type=script&lang=js"
export * from "./ProductOptionExCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__